// Router Helper Utility
// This enables navigation from Firebase service to React Router

let navigateFunction = null;

export const setNavigateFunction = (navigate) => {
  navigateFunction = navigate;
  // Also set it globally for Firebase service access
  window.routerNavigate = navigate;
};

export const navigateTo = (route, options = {}) => {
  if (navigateFunction) {
    navigateFunction(route, options);
  } else if (window.routerNavigate) {
    window.routerNavigate(route, options);
  } else {
    // Fallback to window.location
    window.location.pathname = route;
  }
};

export const getNotificationData = () => {
  try {
    const data = sessionStorage.getItem('notification_data');
    if (data) {
      const parsed = JSON.parse(data);
      // Clear after reading
      sessionStorage.removeItem('notification_data');
      return parsed;
    }
  } catch (error) {
    console.error('❌ Error getting notification data:', error);
  }
  return null;
};

export const clearNotificationData = () => {
  try {
    sessionStorage.removeItem('notification_data');
  } catch (error) {
    console.error('❌ Error clearing notification data:', error);
  }
};
